import React from 'react';
import styled from 'styled-components';
import { Button } from '../ButtonElement';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  background: #f9fbfd;
  padding: 60px 20px;
  max-width: 1000px;
  margin: 0 auto;
  color: #111;
  line-height: 1.7;
`;

const Headline = styled.h1`
  text-align: center;
  font-size: 2rem;
  color: #010606;
  margin-bottom: 2rem;
`;

const Section = styled.div`
  margin-bottom: 2rem;
`;

const StyledLink = styled.a`
  color: #01bf71;
  font-weight: bold;
  text-decoration: underline;

  &:hover {
    color: #009e5f;
  }
`;

const RemoteSupport = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Headline>Fernwartung mit TeamViewer</Headline>

      <Section>
        <p>
          Für eine sichere und schnelle Fernwartung nutzen wir <strong>TeamViewer</strong>. Mit diesem Tool
          können wir auf Wunsch direkt auf Ihr Gerät zugreifen – natürlich nur mit Ihrer aktiven Zustimmung.
        </p>
        <ul>
          <li>✅ Verschlüsselte Verbindung</li>
          <li>✅ Nur mit Ihrer Freigabe nutzbar</li>
          <li>✅ Für Windows, Mac & mobile Geräte verfügbar</li>
          <li>✅ Keine dauerhafte Installation erforderlich</li>
        </ul>
      </Section>

      <Section>
        <h3>So funktioniert's:</h3>
        <ol>
          <li>
            Öffnen Sie den offiziellen Download-Link:
            <br />
            <StyledLink
              href="https://www.teamviewer.com/de/download/"
              target="_blank"
              rel="noopener noreferrer"
            >
              TeamViewer herunterladen
            </StyledLink>
          </li>
          <li>Starten Sie das Programm („TeamViewer QuickSupport“ reicht aus)</li>
          <li>Teilen Sie uns Ihre **TeamViewer-ID** und das **Passwort** mit</li>
        </ol>
      </Section>

      <Section>
        <h3>Kontakt für Fernwartung:</h3>
        <p>
          <strong>Software Solution</strong><br />
          Tel: <a href="tel:+436601650720">+43 660 165 0720</a><br />
          Mail: <a href="mailto:info@softwaresolution.at">info@softwaresolution.at</a>
        </p>
      </Section>

      <Button onClick={() => navigate('/')}>Zurück zur Startseite</Button>
    </Container>
  );
};

export default RemoteSupport;
